<tm-modal [cancelBtnLabel]="false" [okBtnLabel]="false" panelClass="member-preference-modal" (afterConfirm)="resetData()" (afterCancel)="resetData()" #modal>
  <tm-modal-header>
    <h2>內容偏好設定，請勾選您感興趣的類別</h2>
  </tm-modal-header>
  <tm-modal-body>
    <div class="f3f3f3" *ngIf="memberPreference">
      <div class="row">
          <div class="col-xs-6 col-sm-4 col-md-3" *ngFor="let opt of memberPreference.subjectSubs; index as i;trackBy: trackByFn">
              <input type="checkbox" id="cbox{{i}}" name="cbox{{i}}" class="checkbox" [checked]="opt.isFavorite" [(ngModel)]="opt.isFavorite">
              <label for="cbox{{i}}"><span>{{ opt.name }}</span></label>
          </div>
      </div>
  </div>
  </tm-modal-body>
  <tm-modal-footer>
    <div *ngIf="showNever"><input type="checkbox" name="disablePop" id="disablePop" [(ngModel)]="memberPreference.disablePop">不再顯示此視窗</div>
    <button type="button" class="yellow_btn" data-dismiss="modal" (click)="save()">確定</button>
  </tm-modal-footer>
</tm-modal>
